import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-info-modal',
    imports: [
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle
    ],
    templateUrl: './info-modal.component.html',
    styleUrl: './info-modal.component.scss'
})
export class InfoModalComponent {

    public title: string;
    public text: string;
    protected action: () => void;

    constructor(@Inject(MAT_DIALOG_DATA) data: {
        title: string,
        text: string,
        action: () => void
    },          private dialogRef: MatDialogRef<InfoModalComponent>) {
        this.title = data.title;
        this.text = data.text;
        this.action = data.action;
    }

    ok(): void {
        this.dialogRef.close();
        if (this.action) {
            this.action();
        }
    }

}
